import React from 'react';
import { SimpleGrid } from '@wegroup/design-system';
import { InsurancePolicyPackage } from '../../../../../../types/AdvisoryReport';
import LabeledParamFallback from '../../../../../../../../common/src/components/label-param-fallback/LabelParamFallback';
import { useTranslation } from 'react-i18next';
import { toEuro } from '../../../../../../../../sales-conversation/src/utils/stringUtils';
import { format, isValid } from 'date-fns';

interface Props {
  data: InsurancePolicyPackage;
}

const InsurancePolicyPackageItemInfo: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const date =
    data.due_date && isValid(new Date(data.due_date))
      ? format(new Date(data.due_date), 'dd/MM')
      : undefined;

  return (
    <SimpleGrid pt="2" pb="4" columns={4} gridGap="4">
      <LabeledParamFallback
        label={t('ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_PACKAGE-NR')}
      >
        {data.package_nr}
      </LabeledParamFallback>
      <LabeledParamFallback
        label={t(
          'ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_INSURANCE-COMPANY',
        )}
      >
        {data.insurance_company}
      </LabeledParamFallback>
      <LabeledParamFallback
        label={t('ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_EXPIRATION-DATE')}
      >
        {date}
      </LabeledParamFallback>
      <LabeledParamFallback
        label={t('ADVISORY-REPORTS_CURRENT-INSURANCE_OVERVIEW_PREMIUM')}
      >
        {toEuro(data.premium) + ' / ' + t(data.payment_interval)}
      </LabeledParamFallback>
    </SimpleGrid>
  );
};

export default InsurancePolicyPackageItemInfo;
